import React from "react";
import { useT } from "@/lib/LanguageContext";

// En-tête de page (titre produit) — la navigation prev/next/today et le switch de
// vue mois/semaine/jour sont désormais portés par le headerToolbar de FullCalendar
// lui-même (voir BookingCalendar.jsx), donc plus dupliqués ici.
export const CalendarToolbar = () => {
  const t = useT("admin");
  return (
    <div>
      <h1 className="font-display text-3xl text-eh-ink">{t("cal.title")}</h1>
      <p className="text-eh-muted text-sm">{t("cal.subtitle")}</p>
    </div>
  );
};
